import TableTemplate, {
  IExtraTypeUIProps,
} from "../TableTemplate/tableTemplate";
import { CommonTableUI } from "../TableTemplate/common";
import { getOptionGreekTable } from "../../Requests/optionGreek";
import {
  IOptionGreekSearchParam,
  IOptionsGreekTableReport,
} from "../../Interfaces/optionGreek";
import { ExtraType } from "../../Interfaces/TableInterfaces";
import WithChartCell from "./WithChartCell";
import ChainStatusChartCell from "./ChainStatusChartCell";

interface IProps {
  showHiddenCols: boolean;
  searchParam: IOptionGreekSearchParam;
}

const OptionGreekTable = ({ showHiddenCols, searchParam }: IProps) => {
  const getExtraTypeUI = ({
    headerName,
    extraType,
    row,
    cellType,
    translateHeaderName,
  }: IExtraTypeUIProps<IOptionsGreekTableReport>) => {
    switch (extraType) {
      case ExtraType.WithChart:
        if (headerName === "ChainStatus")
          return (
            <ChainStatusChartCell
              cellType={cellType}
              headerName={headerName}
              row={row}
              extraType={extraType}
              translateHeaderName={translateHeaderName}
            />
          );

        return (
          <WithChartCell
            cellType={cellType}
            headerName={headerName}
            row={row}
            extraType={extraType}
            translateHeaderName={translateHeaderName}
          />
        );

      default:
        return <></>;
    }
  };

  return (
    <TableTemplate
      TableUI={({ reports, sortingType, setSortingType, getExtraTypeUI }) => (
        <CommonTableUI
          reports={reports}
          showHiddenCols={showHiddenCols}
          tableBoxClassName="max-h-[500px]"
          sortingType={sortingType}
          setSortingType={setSortingType}
          getExtraTypeUI={getExtraTypeUI}
        />
      )}
      getDataTable={getOptionGreekTable}
      withSort
      searchParameters={searchParam}
      refreshTableTime={20000}
      getExtraTypeUI={getExtraTypeUI}
    />
  );
};

export default OptionGreekTable;
